import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useAudio } from '../context/AudioManagementContext';

function Button({ onClick, className, type, disabled, title, children }) {
  const { playClick, playHover } = useAudio();
  const [wait, setWait] = useState(false);
  const clickTimeout = useRef(null);

  const debounceClick = (event) => {
    if (event) {
      if (event.stopPropagation) event.stopPropagation();
      if (event.cancelable && !event.isDefaultPrevented())
        event.preventDefault();
    }
    if (wait) return;
    setWait(true);

    playClick(0.5, () => onClick && onClick(event));

    if (clickTimeout.current) {
      clearTimeout(clickTimeout.current);
    }

    clickTimeout.current = setTimeout(() => {
      setWait(false);
    }, 300);
  };

  const onHover = () => {
    playHover(0.2);
  };

  return (
    <button
      className={`${className}`}
      type={type}
      onClick={debounceClick}
      onTouchStart={debounceClick}
      onMouseEnter={onHover}
      disabled={disabled}
      title={title}
    >
      {children}
    </button>
  );
}

Button.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  children: PropTypes.any
};

export default Button;
